import { render, staticRenderFns } from "./WorkInsights.vue?vue&type=template&id=48dfb337"
import script from "./WorkInsights.vue?vue&type=script&lang=js"
export * from "./WorkInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports